import React from 'react';
import { Alert, Button, Snackbar } from '@mui/material';
import { useGoogleLogin } from '@react-oauth/google';
import { useAuth } from '../hooks/useAuth';

/**
 * Non-disruptive banner shown when the session token has expired and
 * silent refresh failed. Lets the user re-authenticate with one click
 * without losing any unsaved work.
 */
const ReauthBanner: React.FC = () => {
  const { needsReauth, login } = useAuth();

  const handleReauth = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        });
        const userInfo = res.ok ? await res.json() : {};
        login(tokenResponse.access_token, userInfo.email || '');
      } catch {
        // If userinfo fails, still store the token
        login(tokenResponse.access_token, '');
      }
    },
    scope: 'openid email profile',
  });

  if (!needsReauth) return null;

  return (
    <Snackbar
      open
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        severity="warning"
        variant="filled"
        action={
          <Button color="inherit" size="small" onClick={() => handleReauth()}>
            Sign in again
          </Button>
        }
      >
        Your session has expired. Click to sign in again — your work is safe.
      </Alert>
    </Snackbar>
  );
};

export default ReauthBanner;
